import { ai } from './ai';
import { auth } from './auth';
import { components } from './components';
import { content } from './content';
import { home } from './home';
import { inbox } from './inbox';
import { integrations } from './integrations';
import { notifications } from './notifications';
import { onboarding } from './onboarding';
import { products } from './products';
import { reports } from './reports';
import { sales } from './sales';
import { settings } from './settings';
import { shell } from './shell';
import { shoppers } from './shoppers';
import { waiting } from './waiting';

// The merchant panel's screen strings (WS-16), keyed merchant.<area>.<key> (UI architecture §10).
export const merchant = {
  shell,
  components,
  auth,
  onboarding,
  home,
  inbox,
  waiting,
  shoppers,
  products,
  content,
  sales,
  reports,
  ai,
  integrations,
  settings,
  notifications,
} as const;
